import { httpsCallable } from 'firebase/functions';
import { fns } from '@/firebase';
import type {
  DetectPlatformInput,
  DetectPlatformResult,
  ProcessMediaInput,
  ProcessMediaResult,
} from '@/types';

export async function callDetectPlatform(input: DetectPlatformInput): Promise<DetectPlatformResult> {
  const fn = httpsCallable<DetectPlatformInput, DetectPlatformResult>(fns(), 'detectPlatform');
  return (await fn(input)).data;
}

export async function callProcessMedia(input: ProcessMediaInput): Promise<ProcessMediaResult> {
  const fn = httpsCallable<ProcessMediaInput, ProcessMediaResult>(fns(), 'processMedia', {
    timeout: 540_000,
  });
  return (await fn(input)).data;
}

export async function callGenerateSnapshots(input: ProcessMediaInput): Promise<ProcessMediaResult> {
  const fn = httpsCallable<ProcessMediaInput, ProcessMediaResult>(fns(), 'generateSnapshots', {
    timeout: 540_000,
  });
  return (await fn(input)).data;
}

export function functionsErrorMessage(error: unknown): string {
  const err = error as { code?: string; message?: string };
  switch (err.code) {
    case 'functions/resource-exhausted':
      return 'Daily download limit reached. Sign in for a higher limit or come back tomorrow.';
    case 'functions/invalid-argument':
      return err.message ?? 'That URL is not supported.';
    case 'functions/failed-precondition':
      return err.message ?? 'This content can’t be processed — it may be private or unavailable.';
    case 'functions/unauthenticated':
      return 'Please sign in and try again.';
    case 'functions/deadline-exceeded':
      return 'Processing took too long — try a shorter video or lower quality.';
    default:
      return err.message ?? 'Processing failed. Please try again.';
  }
}
